import { post } from "../utils/apiManager";
import { baseURL } from "../config/config";
import { toast } from 'react-toastify';
import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from 'react-router-dom';

const OTP = () => {
  const { id } = useParams();
  const location = useLocation();
  // The new password comes from the previous screen in memory (never in the address bar)
  const password = location.state?.password;
  const Navigate = useNavigate();
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [loading, setLoading] = useState(false);
  const otpInputRefs = [];

  useEffect(() => { if (!id || !password) Navigate("/auth/forgot-password"); }, [id, password]);

  const handleOtpChange = (index, value) => {
    if (isNaN(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value !== '' && index < otp.length - 1) otpInputRefs[index + 1].focus();
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && index > 0 && otp[index] === '') otpInputRefs[index - 1].focus();
  };

  const onSubmit = () => {
    if (otp.some(d => d === '')) return toast.error("Please enter the complete OTP");
    setLoading(true);
    post(`${baseURL}/admin/otp-verified`, { otp: otp.join(""), password, validateString: id })
      .then((res) => { setLoading(false); if (res?.status) { toast.success(res.message); Navigate("/auth/login"); } else toast.error(res?.message); })
      .catch((err) => { setLoading(false); toast.error(err?.response?.data?.error); });
  };

  return (
    <div style={{ width: '100%', maxWidth: 420, fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 8px 32px rgba(26,39,68,.12)', overflow: 'hidden', padding: '40px 36px' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ width: 52, height: 52, borderRadius: 14, background: '#fee2e2', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, margin: '0 auto 14px' }}>📧</div>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: '#0a1628', margin: '0 0 6px', letterSpacing: '-0.5px' }}>Enter OTP</h2>
          <p style={{ fontSize: 14, color: '#9aa5c0', margin: 0 }}>Enter the 6-digit code sent to your email</p>
        </div>

        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginBottom: 28 }}>
          {otp.map((digit, index) => (
            <input
              key={index}
              type="text"
              maxLength={1}
              value={digit}
              onChange={(e) => handleOtpChange(index, e.target.value)}
              onKeyDown={(e) => handleOtpKeyDown(index, e)}
              ref={(ref) => otpInputRefs[index] = ref}
              style={{
                width: 48, height: 58, textAlign: 'center', fontSize: 24, fontWeight: 700,
                borderRadius: 10, border: `2px solid ${digit ? '#AD2429' : '#e2e8f0'}`,
                color: '#0a1628', outline: 'none', fontFamily: 'inherit',
                background: digit ? '#fff8f8' : '#fff', transition: 'all .15s',
              }}
            />
          ))}
        </div>

        <button onClick={onSubmit} disabled={loading} style={{ width: '100%', padding: '12px', background: '#AD2429', color: '#fff', border: 'none', borderRadius: 9, fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit', opacity: loading ? 0.7 : 1, marginBottom: 16 }}>
          {loading ? 'Verifying...' : 'Verify OTP'}
        </button>
        <div style={{ textAlign: 'center' }}>
          <a href="/auth/forgot-password" style={{ fontSize: 13, color: '#9aa5c0', textDecoration: 'none' }}>← Start over</a>
        </div>
      </div>
    </div>
  );
};

export default OTP;
